export const CreateLocalSaving = (data) => {
    //обертка из parse и  stringify нужна чтобы не редактировать data!!
    const result=JSON.parse(JSON.stringify(data));
    Object.keys(data).forEach((partName)=>{
        Object.keys(data[partName]).forEach((categoryName)=>{
            Object.keys(data[partName][categoryName]).forEach((levelName)=>{
                Object.keys(data[partName][categoryName][levelName]).forEach((taskName)=>{
                    result[partName][categoryName][levelName][taskName]={
                        "result":data[partName][categoryName][levelName][taskName].result,
                        "comment":data[partName][categoryName][levelName][taskName].comment,
                        "changed":false
                    }
                })
            })
        })
    })

    const localData={
            "saving":false,
            "data":result
    }
    return(localData);
}